var trains = {

	chilternrailways : function() {

		var $defaultFrom,
			$defaultTo;

		$('#chilternrailways #chiltern-from, #chilternrailways #chiltern-to').change(function(){
			$('#chilternrailways .results .tbody .tr').remove();
			$('#chilternrailways .loading-dots').show();
			$('#chilternrailways .timestamp').hide();
			refreshTimetable();
		});

		function refreshTimetable() {
			$defaultFrom = $('#chilternrailways #chiltern-from').val();
			$defaultTo = $('#chilternrailways #chiltern-to').val();

			var XML = "https://query.yahooapis.com/v1/public/yql?q=select%20*%20from%20html%20where%20url%3D%22http%3A%2F%2Fojp.nationalrail.co.uk%2Fservice%2Fldbboard%2Fdep%2F"+$defaultFrom+"%2F"+$defaultTo+"%2FTo%22%20and%0A%20%20%20%20%20%20xpath%3D'%2F%2Fdiv%5B%40class%3D%22tbl-cont%22%5D%2Ftable%2Ftbody'";

			$.ajax({
				type: "GET",
				url: XML,
				dataType: "xml"
			}).done(function (data) {

				var $dataRow = $(data).find('tr');
				// Grabbing the text from the templete for translation purposes
				var platformTitle = $('.platform-title').text();
				// Get date
				var date = new Date();
				var hours = date.getHours();
				var minutes = date.getMinutes();

				// If has data
				if ( $dataRow.length > 0 ) {
					// Iterate over data rows and compile a table to append
					$(data).find('tr').each(function() {
						var $due = $(this).find('td:eq(0)').text();
						var $class = $(this).attr('class');
						var $destination = $(this).find('td:eq(1)').text();
						var $status = $(this).find('td:eq(2)').text();
						var $platform = $(this).find('td:eq(3)').text();

						$('<div class="tr ' + $class + '" />').html('<div class="td">' + $due + '</div><div class="td">' + $destination + '</div><div class="td">' + $status + '</div><div class="td"><span class="platform">' + platformTitle + ' </span>' + $platform + '</div>').appendTo('#chilternrailways .results .tbody');
					});
				} else {
					// Get the text from the hidden el on page
					var noTrainsText = $('.no-trains-text').html();
					// Append a tr to the tbody
					$('<div class="tr no-trains"><div class="td"></div></div>').appendTo('#chilternrailways .results .tbody');
					// Add text to the tr
					$('#chilternrailways .results .no-trains').html(noTrainsText);
				}

				$('#chilternrailways .timestamp').text('Last Updated: ' + hours + ':' + minutes);

				$('#chilternrailways .loading-dots').hide();
				$('#chilternrailways .timestamp').show();
			});
		}

		refreshTimetable();
	},


	init: function() {
		if ( $('#chilternrailways').length > 0 ) {
			trains.chilternrailways();
		}
	}
};
